<div class="header-wrapper" (click)="doSort()">
  <div class="header" [class.header-active]="sort.direction != SortDirection.NONE && !hideArrows">{{ header }}</div>
  <div class="arrows" *ngIf="!hideArrows">
    <div class="up-arrow" [class.active]="sort.direction == SortDirection.ASC"></div>
    <div class="down-arrow" [class.active]="sort.direction == SortDirection.DESC"></div>
  </div>
</div>
<div class="subheader" *ngIf="subheader" [class.header-active]="sort.direction != SortDirection.NONE && !hideArrows">{{ subheader }}</div>
